import { updateNavigationLink } from '../core/navigation.js';

/** Shared navigation links for previews, catalog cards and product details. */
export function createProductActions(document, prefix = 'positive-nav-preview', { discoverLabel = 'actions.discover', source = 'preview' } = {}) {
  const element = document.createElement('div');
  element.className = `${prefix}-actions`;
  const action = (variant) => {
    const link = document.createElement('a');
    link.className = `positive-nav-action positive-nav-action-${variant} ${prefix}-action ${prefix}-action-${variant}`;
    link.dataset.action = 'navigate';
    const label = document.createElement('span');
    label.className = `${prefix}-action-label`;
    link.append(label);
    element.append(link);
    return { link, label };
  };
  const primary = action('primary');
  const secondary = action('secondary');
  return {
    element, primary, secondary,
    update(product, t, currentProductId) {
      const secondaryFocused = secondary.link.getRootNode().activeElement === secondary.link;
      const destination = product.isConnected ? 'app': 'try';
      primary.link.dataset.destination = destination;
      updateNavigationLink(primary.link, { url: product.urls[destination], source, destination }, currentProductId);
      primary.label.textContent = t(product.isConnected ? 'actions.signIn': 'actions.tryFree');
      primary.link.setAttribute('aria-label', `${primary.label.textContent} · ${product.name} · ${t('accessibility.newTab')}`);
      secondary.label.textContent = t(discoverLabel, { product: product.name });
      secondary.link.dataset.destination = 'discover';
      secondary.link.setAttribute('aria-label', `${t('actions.discoverProduct', { product: product.name })} · ${t('accessibility.newTab')}`);
      secondary.link.hidden = product.isConnected;
      if (product.isConnected) secondary.link.removeAttribute('href');
      else updateNavigationLink(secondary.link, { url: product.urls.discover, source, destination: 'discover' }, currentProductId);
      if (product.isConnected && secondaryFocused) primary.link.focus({ preventScroll: true });
    },
  };
}
